import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'

export const HeaderFlex = styled(Flex)`
  gap: 15px;
  margin: 15px 0;
`
export const SearchDiv = styled.div`
  flex: 1;
`
export const InterviewerDiv = styled.div`
  margin: 10px 0;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
`
export const ReplaceDiv = styled.div`
margin-top:30px;
`

export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const CollageDetailsFlexing = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  padding: 17px 0px;
  display : flex;
  gap:30px;
`

export const ReplaceTextDiv = styled.div`
width: 68px;
height: 23px;
padding: 4px 75px 25px 12px;
border-radius: 6px;
background: #F2F3F5;
`

export const CollegeNameDivText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 8px;
`


export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const CollegeCitys = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
  margin-top:15px
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  padding: 17px 0px;
  border-bottom: ${props =>
    !props?.isBoader && `1px solid ${COLORS.GREY_T_90}`};
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`
export const EmtyWrapper = styled(Flex)`
  padding-top: 30%;
  color: ${COLORS.GREY_T_60};
`
export const ClikcEvent = styled.div`
  cursor: pointer;
`
